module.exports = __webpack_public_path__ + "static/media/data_science_image.bfaf3f0c.jpg";